/**
 * Aplicação de Fontes Geradoras (#606): o inventário comum (`InventarioDoDestino`) com a configuração de fontes — para
 * quem, o que já vale ali e o botão para adicionar mais, tudo gravado na hora.
 */
import { InventarioDoDestino } from '../../components/applications/InventarioDoDestino';
import { usePermissoesDaAplicacao } from '../../components/applications/permissoesDaAplicacao';
import { CONFIG_DE_FONTES } from './configDeFontes';

const MIGALHAS = [
  { label: 'Início', path: '/' },
  { label: 'Segurança', path: '/seguranca' },
  { label: 'Aplicação de Fontes Geradoras' },
];

export function SourceApplicationPage() {
  const permissoes = usePermissoesDaAplicacao('source');
  return <InventarioDoDestino config={CONFIG_DE_FONTES} breadcrumbs={MIGALHAS} permissoes={permissoes} />;
}

export default SourceApplicationPage;
